<template>
    <div>
        <SimpleTable
            :flat="true"
            title="Resumen de plazos"
            subtitle="Resumen de plazos por mes"
            :columns="columns"
            :data="plazos"
            :skeleton="loading"
            :skeleton-rows="5"
            :empty-text="'No hay plazos'"
            :default-col-width="defaultColWidth"
        >
            <!-- Skeleton headers -->
            <template #skeleton-header-mes>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-16"></div>
            </template>
            <template #skeleton-header-pagados>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-header-pendientes>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>
            <template #skeleton-header-total>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-10"></div>
            </template>

            <!-- Skeleton rows -->
            <template #skeleton-mes>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-28"></div>
            </template>
            <template #skeleton-pagados>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-pendientes>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-total>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>

            <template #footer>
                <tr class="tw:bg-gray-50">
                    <td class="tw:px-6 tw:py-3 tw:font-semibold">TOTAL</td>
                    <td class="tw:px-6 tw:py-3 tw:text-center">{{ totalPagados }}</td>
                    <td class="tw:px-6 tw:py-3 tw:text-center">{{ totalPendientes }}</td>
                    <td class="tw:px-6 tw:py-3 tw:text-center">{{ totalGeneral }}</td>
                </tr>
            </template>
        </SimpleTable>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue';

    const props = defineProps({
        listaId: { type: [Number, String], required: true },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    });

    const loading = ref(false);
    const plazos = ref([]);

    const columns = [
        { key: 'mes', label: 'Mes' },
        { key: 'pagados', label: 'Pagados', class: 'tw:w-28', centered:true},
        { key: 'pendientes', label: 'Pendientes' , class: 'tw:w-28', centered:true},
        { key: 'total', label: 'Total' , class: 'tw:w-28', centered:true}
    ];

    const totalPagados = computed(() => {
        return plazos.value.reduce((sum, row) => sum + (Number(row.pagados) || 0), 0);
    });

    const totalPendientes = computed(() => {
        return plazos.value.reduce((sum, row) => sum + (Number(row.pendientes) || 0), 0);
    });

    const totalGeneral = computed(() => totalPagados.value + totalPendientes.value);

    onMounted(async() => {
        loading.value = true;
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.informe.plazos-por-mes'),
                { lista_id: props.listaId, filters: {} }
            );
            plazos.value = (res.data.plazos_por_mes || []).map(row => ({
            ...row,
            total: (Number(row.pagados) || 0) + (Number(row.pendientes) || 0)
            }));
        } catch (e) {
            console.error('Error fetching plazos por mes:', e);
        } finally {
            loading.value = false;
        }
    });
</script>
